import { render } from "./Older.vue?vue&type=template&id=4537eae8"
import script from "./Older.vue?vue&type=script&lang=js"
export * from "./Older.vue?vue&type=script&lang=js"
script.render = render

export default script